<ng-container *ngFor="let item of items">
  <label class="radio-item radio-primary pb-2 pe-4 mb-1"
         [class.checked]="item.id === model?.id">
    <input type="radio"
           value="{{item.id}}"
           [checked]="item.id === model?.id"
           [value]="item"
           (change)="model = item"/>
    {{ item.label }}
  </label>
</ng-container>
